import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../environments/environment';

/**
 * Generated class for the ImagePipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'image',
})
export class ImagePipe implements PipeTransform {
  transform(value: string, arg1) {
    if (value && value.includes('http')) {
      return value;
    } else if (value && value != 'null') {
      if (arg1 != 'evento') {
        return environment.DOWNLOAD_URL + '/' + value;
      } else {
        return environment.BACKEND_IMG_URL + '/' + value;
      }
    } else {
      /** quando sem foto no contribua adiciona imagem padrão */
      if (arg1 == 'contribua') {
        return environment.IMG_URL + '/placeholder-contribua.png';
      }

      if (arg1 == 'evento') {
        return environment.IMG_URL + '/not_found.png';
      }

      return 'assets/imgs/placeholder.jpg';
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/image/image.ts